import { z } from 'zod';

const positionRefSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const orgUnitRefSchema = z.object({
  id: z.string(),
  name: z.string(),
});

/** GET /v1/employees — элемент списка */
export const employeeListItemSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  position: positionRefSchema,
  org_unit: orgUnitRefSchema,
  is_active: z.boolean(),
});

export type EmployeeListItem = z.infer<typeof employeeListItemSchema>;

export const employeeListResponseSchema = z.object({
  employees: z.array(employeeListItemSchema),
  next_page_token: z.string().nullable().optional(),
});

export type EmployeeListResponse = z.infer<typeof employeeListResponseSchema>;

/** GET /v1/employees/:id — карточка сотрудника */
export const employeeProfileSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  tab_number: z.string().nullable().optional(),
  is_active: z.boolean(),
  position: positionRefSchema,
  org_unit: orgUnitRefSchema,
});

export type EmployeeProfile = z.infer<typeof employeeProfileSchema>;

export const employeeProfileResponseSchema = z.object({
  employee: employeeProfileSchema,
});

export type EmployeeProfileResponse = z.infer<typeof employeeProfileResponseSchema>;
